import { render, staticRenderFns } from "./KycIPVDetails.vue?vue&type=template&id=37898eb8&scoped=true&"
import script from "./KycIPVDetails.vue?vue&type=script&lang=js&"
export * from "./KycIPVDetails.vue?vue&type=script&lang=js&"
import style0 from "./KycIPVDetails.vue?vue&type=style&index=0&id=37898eb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37898eb8",
  null
  
)

export default component.exports